import { useState } from "react";
import { Button } from "./Button";

type CopyButtonProps = {
  /** Text put on the clipboard */
  value: string;
  /** Button text */
  label?: string;
};

/** Copies a value and says so for a moment. */
export const CopyButton = ({ value, label = "Copy" }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  };
  return (
    <Button variant="secondary" size="sm" onClick={copy}>
      {copied ? "Copied" : label}
    </Button>
  );
};
